<template>
  <div>
    <!-- EACH PRODUCT -->
    <EquipmentItemAdjuster v-for="(e, index) in equipment" :item="e" :key="index" />
  </div>
</template>

<script>

import EquipmentItemAdjuster from './EquipmentItemAdjuster'

export default {
  props: {
    equipment: {
      type: Array,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false,
    }
  },

  components: {
    EquipmentItemAdjuster
  },
  
};
</script>

